import { Dispatch } from 'redux';
import { apiAction } from '../../../TCSMApp/global/ducks/base-api';
import { ApiAction, HttpMethods } from '../../../TCSMApp/global/models/api-model';
import { KeyValuePair } from '../../../TCSMApp/pages/arc/models/arc-epi-props';
import { ClergyFilters, ClergySearchSort } from '../components/clergy/clergy-model';
import { ApiEndpoint } from '../constants/api-endpoints';
import { EcdClergySettingsProps } from '../models/epi-model';

export const cleargyNameAutocompletePath = 'search/clergy_name.json';
export const cleargyLocationAutocompletePath = 'search/clergy_location.json';
export const cleargySearchPath = 'search/clergy.json';
export const cleargyDetailPath = 'clergies/';
export const canonnicalResidencePath = 'search/canonical_residences.json';
export function QuickSearchByName(
	partialName: string, 
	onSuccess: (data: any, dispatch?: Dispatch<any>) => any, 
	onFailure?: (dispatch?: Dispatch<any>) => any,
	): ApiAction {
	return apiAction({
		method: HttpMethods.GET,
		url: `${ApiEndpoint.ecdPlusPrc}${cleargyNameAutocompletePath}?val=${partialName}`,		
		onSuccess,
		onFailure,
	});
}

export function QuickSearchByLocation(
	partialName: string, 
	onSuccess: (data: any, dispatch?: Dispatch<any>) => any, 
	onFailure?: (dispatch?: Dispatch<any>) => any,
	): ApiAction {
	return apiAction({
		method: HttpMethods.GET,
		url: `${ApiEndpoint.ecdPlusPrc}${cleargyLocationAutocompletePath}?val=${partialName}`,		
		onSuccess,
		onFailure,
	});
}

export function Search(
	filters: ClergyFilters, 
	onSuccess: (data: any, dispatch?: Dispatch<any>) => any, 
	onFailure?: (dispatch?: Dispatch<any>) => any,
	): ApiAction {

	const formData = new FormData();		

	if (filters?.location){
		formData.append('location', filters?.location?.trim());
	}

	if (filters?.name){
		formData.append('name', filters?.name?.trim());
	}

	if (filters?.first_name){
		formData.append('first_name', filters?.first_name?.trim());
	}

	if (filters?.last_name){
		formData.append('last_name', filters?.last_name?.trim());
	}

	if (filters?.is_bishop){
		formData.append('is_bishop', filters?.is_bishop?.trim());
	}

	if (filters?.c_res?.length > 0){
		const cResValues = Array.isArray(filters.c_res) ?  (filters.c_res as any) as string[] : filters.c_res?.split(',');

		cResValues.forEach(cres => {
			formData.append('c_res[]', cres);
		});
	}

	if (filters?.sort){
		formData.append('sort', filters?.sort);
	}

	if (filters?.zip_code){
		formData.append('zip_code', filters?.zip_code?.trim());
	}	

	return apiAction({
		method: HttpMethods.POST,
		payloadData: null,
		url: `${ApiEndpoint.ecdPlusPrc}${cleargySearchPath}`,		
		formData,
		contentType: 'multipart/form-data',
		onSuccess,
		onFailure,
	});
}

export function GetDetail(
	clergyId: string | number, 
	onSuccess: (data: any, dispatch?: Dispatch<any>) => any, 
	onFailure?: (dispatch?: Dispatch<any>) => any,
	): ApiAction {
	return apiAction({
		method: HttpMethods.GET,		
		url: `${ApiEndpoint.ecdPlusPrc}${cleargyDetailPath}${clergyId}.json`,		
		onSuccess,
		onFailure,
	});
}

export function GetBishopOptions(clergySettings: EcdClergySettingsProps){
	const options = [];

	options.push({ value: 'No', text: clergySettings?.bishopNoItem || 'No' });	
	options.push({ value: 'Yes', text: clergySettings?.bishopYesItem || 'Yes' });

	return options;
}

export function GetCanonicalResidence(
	onSuccess: (data: any, dispatch?: Dispatch<any>) => any,
	onFailure?: (dispatch?: Dispatch<any>) => any,
): ApiAction {
	return apiAction({
		method: HttpMethods.GET,
		url: `${ApiEndpoint.ecdPlusPrc}${canonnicalResidencePath}`,
		onSuccess,
		onFailure,
	});
}


export function mapCanonicalResidence(value: string, mapList: KeyValuePair[]): string {

	if (mapList?.length > 0){		
		return mapList.find(v => value?.toLocaleLowerCase() === v?.key.toLocaleLowerCase())?.value || value;
	}
	
	return value;
}

function mapClergyType(value: string, mapList: KeyValuePair[]): string {

	if (mapList?.length > 0){		
		return mapList.find(v => value?.toLocaleLowerCase() === v?.key.toLocaleLowerCase())?.value || value;
	}
	
	return value;
}

export const apiOrderByOptions : string[][] = [
	[ ClergySearchSort.LastNameAsc, 'Last Name A-Z'],
	[ ClergySearchSort.LastNameDesc, 'Last Name Z-A'],
	[ ClergySearchSort.FirstNameAsc, 'First Name A-Z'],
	[ ClergySearchSort.FirstNameDesc, 'First Name Z-A'],	
	[ ClergySearchSort.CityAsc, 'City A-Z'],
	[ ClergySearchSort.CityDesc, 'City Z-A'],
	[ ClergySearchSort.StateAsc, 'State A-Z'],
	[ ClergySearchSort.StateDesc, 'State Z-A'],
	];

export function GetClergyOrderByOptions(orderByMapping: KeyValuePair[]){
	return apiOrderByOptions.map(item => { return { value: item[0], text: mapClergyType(item[1], orderByMapping) }; });
}